import DashboardLayout from '../layouts/DashboardLayout'
// import CallCenterList from '../pages/call-center/CallCenterList';
// import ReportEmployees from "../pages/call-center/employee-report/ReportEmployees";
// import CallCenterReport from '../pages/call-center/general-report/CallCenterReport'

export const CallCenterMenu = {
  path: '/call-center',
  component: DashboardLayout,
  name: 'CallCenterReport',
  redirect: '/call-center',
  children: [
    {
      path: 'list',
      name: 'CallCenterList',
      component: () => import(/* webpackChunkName: "about" */'../pages/call-center/CallCenterList.vue'),
      meta: {
        roles: ['call_center_read','call_center_delete','call_center_view_all'],
        requiresAuth: true,
        breadcrumb: [{
          title: "Danh sách cuộc gọi"
        }]
      },
    },
    {
      path: 'general-report',
      name: 'CallCenterReport',
      component: () => import(/* webpackChunkName: "about" */'../pages/call-center/general-report/CallCenterReport.vue'),
      meta: {
        roles: ['general-call-center-report_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: "Báo cáo call center"
        }]
      },
    },
    {
      path: 'employee-report',
      name: 'ReportEmployees',
      component: () => import(/* webpackChunkName: "about" */'../pages/call-center/employee-report/ReportEmployees.vue'),
      meta: {
        roles: ['employee-call-center-report_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: "Báo cáo cuộc gọi nhân viên"
        }]
      },
    },
  ],
}